import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import axios from "axios";
import moment from "moment";
import React, { useContext, useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { increment } from "../../features/resultSlice";
import { scanResultQueue } from "../../scanResultQueue";
import { updateTransaction, resumeScan } from "../../services/transactions";
import BatchNumberFinder from "../BatchNumberFinder";
import useStyles from "./styles";
import { MyContext } from "../ContextApi";
var failedImages = [];

const ScanResult = ({ closeModal, setScanActive }) => {
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [value, setValue] = useState()
  const [multipleData, setMultipleData] = useState([])
  const { getDecryptedSessionItem } = useContext(MyContext)
  const containerRef = useRef(null)
  const batchInputRef = useRef(null)

  const handleClickListItem = () => {
    setOpen(true)
  }

  const handleClose = (newValue) => {
    setOpen(false)

    if (newValue) {
      setValue(newValue)
    }
  }

  const classes = useStyles()
  const [currentItem, setCurrentItem] = useState(null)
  const dispatch = useDispatch()

  const listenFirebaseEvents = async () => {
    const url = `${getDecryptedSessionItem("server")}/scan/result`
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`,
        },
      })
      .then((results) => {
        if (results.data.data.length > 0 && results.data.data.length < 2) {

          failedImages.unshift(results.data.data[0])

          scanResultQueue.clearProcessingQueue()
          for (let i = failedImages.length - 1; i >= 0; i--) {
            const elem = failedImages[i]
            if (
              elem.status === "error" ||
              (elem.status === "success" &&
                (elem.searchType === "manual" ||
                  elem.searchType === "manual-fz" ||
                  elem.searchType === "manual-fb"))
            ) {
              scanResultQueue.addItem(elem, elem?.id)
            }
          }
          dispatch(increment())
          getNextItem()
        } else if (results.data.data.length > 1) {
          handleClickListItem()
          setMultipleData(results.data.data.reverse())
        }
      })
  }

  useEffect(() => {
    const intervalId = setInterval(() => {
      listenFirebaseEvents()
    }, 500)
    getNextItem()

    return () => clearInterval(intervalId)
  }, [])

  const [barcode1, setBarcode1] = useState("")
  const [barcode2, setBarcode2] = useState("")
  const [batch, setBatch] = useState("")
  const [expiry, setExpiry] = useState("expiry")
  const [id, setId] = useState("")
  const [itemCode, setItemCode] = useState("")
  const [mfg, setMfg] = useState("")
  const [mrp, setMRP] = useState("")
  const [oBatch, setOBatch] = useState("")
  const [optional1, setOptional1] = useState("")
  const [optional2, setOptional2] = useState("")
  const [scannedImage, setScannedImage] = useState("")
  const [searchType, setSearchType] = useState("")
  const [sku, setSku] = useState("")
  const [status, setStatus] = useState("")
  const [category, setCategory] = useState("")
  const [quantity, setQuantity] = useState("1")
  const [platform, setPlatform] = useState("")
  const [lrDate, setLrDate] = useState("")
  const [recDate, setRecDate] = useState("")
  const [remark, setRemark] = useState("")
  const [clientCode, setClientCode] = useState("")
  const [clientName, setClientName] = useState("")
  const [region, setRegion] = useState("")
  const [select, setSelect] = useState(false)
  const [isProcessing, setIsProcessing] = useState(false)
  const isProcessingRef = useRef(false)

  const sanitizeValue = (value) => {
    if (typeof value === "string") {
      let sanitizedValue = value.replace(/\t/g, " ").replace(/\r/g, "")
      sanitizedValue = sanitizedValue.replace(/^[=+\-@]/g, "")
      return sanitizedValue
    }
    return value
  }

  const getNextItem = () => {
    const item = scanResultQueue.popItem()
    if (!item) {
      setScanActive(false);
      return;
    }
    setCurrentItem(item)
    setScanActive(true);
    setBarcode1(item["barcode1"] ?? "")
    setBarcode2(item["barcode2"] ?? "")
    setBatch(sanitizeValue(item["batch"]) ?? "")
    if (item["expiry"] !== "nan") {
      setExpiry(
        moment(item["expiry"], [
          "MM-YYYY",
          moment.ISO_8601,
          moment.RFC_2822,
          moment.defaultFormat,
        ])
          .endOf("month")
          .format("YYYY-MM-DD") ?? "nan"
      )
      calculateCategories(
        new Date(
          moment(item["expiry"], [
            "MM-YYYY",
            moment.ISO_8601,
            moment.RFC_2822,
            moment.defaultFormat,
          ])
            .endOf("month")
            .format("YYYY-MM-DD")
        )
      )
    } else {
      setExpiry(item["expiry"] ?? "nan")
    }
    setId(item["id"] ?? "")
    setItemCode(item["itemCode"] ?? "")
    if (item["mfg"] !== "nan") {
      setMfg(
        moment(item["mfg"], [
          "MM-YYYY",
          moment.ISO_8601,
          moment.RFC_2822,
          moment.defaultFormat,
        ])
          .endOf("month")
          .format("YYYY-MM-DD") ?? "nan"
      )
    } else {
      setMfg(item["mfg"] ?? "nan")
    }
    setMRP(sanitizeValue(item["mrp"]) ?? "")
    setOBatch(sanitizeValue(item["obatch"]) ?? "")
    setOptional1(item["optional1"] ?? "")
    setOptional2(item["optional2"] ?? "")
    setScannedImage(item["scannedImage"] ?? "")
    setSearchType(item["searchType"] ?? "")
    setSku(sanitizeValue(item["sku"]) ?? "")
    setStatus(item["status"] ?? "")
    setLrDate(item["lrDate"] ?? "")
    setRecDate(item["recDate"] ?? "")
    setRemark(item["remark"] ?? "")
    setClientCode(item["clientCode"] ?? "")
    setClientName(item["clientName"] ?? "")
    setRegion(item["region"] ?? "")

    setTimeout(() => {
      if (containerRef.current) {
        containerRef.current.focus()
      }
      if (batchInputRef.current) {
        batchInputRef.current.focus()
      }
    }, 100)
  }

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (!currentItem || open || isProcessingRef.current) return
      if (event.key === "Enter" || event.key === "Escape") {
        event.preventDefault()
      }
      if (event.key === "Enter") {
        confirmScan(id)
      } else if (event.key === "Escape") {
        deleteScan(id)
      }
    }

    window.addEventListener("keydown", handleKeyPress)
    return () => {
      window.removeEventListener("keydown", handleKeyPress)
    }
  }, [currentItem, id, open, sku, batch, mrp, expiry, quantity, category, itemCode])

  const confirmScan = async (delete_id) => {
    if (isProcessingRef.current) return;
    const na = "nan"
    if (sku.length == 0 || sku == na) {
      toast.warn("please enter correct product name")
    } else if (batch.length == 0 || batch == na) {
      toast.warn("please enter correct batch number")
    } else if (mrp.length == 0 || mrp == na) {
      toast.warn("please enter correct mrp")
    } else if (expiry.length == 0 || expiry == na) {
      toast.warn("please enter correct expiry date")
    } else if (quantity.length == 0 || quantity == na) {
      toast.warn("please enter quantities")
    } else if (category.length == 0 || category == na) {
      toast.warn("please select Category")
    } else if (itemCode.length == 0 || itemCode == na) {
      toast.warn("please enter correct item code")
    } else {
      isProcessingRef.current = true;
      setIsProcessing(true);
      try {
        const body = {
          quantity,
          category,
          batch,
          expiryDate: expiry
            ? moment(expiry, [
              "MM-YYYY",
              moment.ISO_8601,
              moment.RFC_2822,
              moment.defaultFormat,
            ])
              .endOf("month")
              .format("MM-YYYY")
            : "nan",
          mfgDate: mfg
            ? mfg !== "nan"
              ? moment(mfg, [
                "MM-YYYY",
                moment.ISO_8601,
                moment.RFC_2822,
                moment.defaultFormat,
              ])
                .startOf("month")
                .format("MM-YYYY")
              : "nan"
            : "nan",
          mrp,
          itemCode,
          sku,
          request_id: getDecryptedSessionItem("request_id"),
          session_id: getDecryptedSessionItem("session_id"),
          optional1,
          optional2,
          barcode1,
          barcode2,
          scannedImage,
          searchType: "auto",
          obatch: oBatch === "" ? batch : oBatch,
          input: "",
          clientCode,
          clientName,
          region,
          lrDate,
          recDate,
          remark,
          platform:
            status === "error"
              ? "Manual"
              : searchType === "manual"
                ? "Manual"
                : searchType === "manual-fb"
                  ? "Auto Confirm - FB"
                  : quantity === "1"
                    ? "Auto Confirm - FZ"
                    : "Auto Confirm - Manual",
        }

        const response = await updateTransaction(body)
        if (response["status"] == "success") {
          setQuantity("1")
          toast.success("updated transaction successfully")

          for (let i = 0; i < failedImages.length; i++) {
            if (failedImages[i].id === delete_id) {
              failedImages.splice(i, 1)
              i--
            }
          }

          shouldContinue()
        } else {
          toast.error(response["error"])
        }
      } finally {
        isProcessingRef.current = false;
        setIsProcessing(false);
      }
    }
  }

  const shouldContinue = async () => {
    scanResultQueue.clearProcessingQueue()
    dispatch(increment())

    const count = scanResultQueue.itemCount()
    if (count > 0) {
      getNextItem()
    } else {
      setCurrentItem(null)
      setScanActive(false);
    }
  }

  const deleteScan = async (delete_id) => {
    if (isProcessingRef.current) return;
    isProcessingRef.current = true;
    setIsProcessing(true);
    try {
      for (let i = 0; i < failedImages.length; i++) {
        if (failedImages[i].id === delete_id) {
          failedImages.splice(i, 1)
          i--
        }
      }

      await resumeScan()
      toast.success("successfully deleted transaction")
      shouldContinue()
    } catch (error) {
      console.error("Failed to resume scan on delete:", error)
      toast.error("Failed to resume scan session")
    } finally {
      isProcessingRef.current = false;
      setIsProcessing(false);
    }
  }

  const calculateCategories = (expiryDate) => {
    if (expiryDate) {
      let date = new Date()
      let today = new Date(date.setMonth(date.getMonth() + 1))

      let sixMonthsAgo = new Date(today)
      sixMonthsAgo.setMonth(today.getMonth() - 6)

      const currentMonth = new Date().getMonth() + 1
      const currentYear = new Date().getFullYear()
      const nearExpiryMonth = currentMonth + 2

      const medicineExpiryMonth = expiryDate.getMonth() + 1

      if (getDecryptedSessionItem("reportType") === "intas") {
        if (currentYear > expiryDate.getFullYear()) {
          setCategory("expiry")
        } else if (currentYear < expiryDate.getFullYear()) {
          setCategory("damage")
        } else if (currentYear === expiryDate.getFullYear()) {
          if (currentMonth >= medicineExpiryMonth) {
            setCategory("expiry")
          } else if (medicineExpiryMonth > nearExpiryMonth) {
            setCategory("damage")
          } else {
            setCategory("near expiry")
          }
        }
      } else if (getDecryptedSessionItem("reportType") === "lupin") {
        if (expiryDate < sixMonthsAgo) {
          setCategory("over-expiry")
        } else if (currentYear > expiryDate.getFullYear()) {
          setCategory("expiry")
        } else if (currentYear < expiryDate.getFullYear()) {
          setCategory("damage")
        } else if (currentYear === expiryDate.getFullYear()) {
          if (currentMonth >= medicineExpiryMonth) {
            setCategory("expiry")
          } else if (medicineExpiryMonth <= nearExpiryMonth && medicineExpiryMonth >= currentMonth) {
            setCategory("expiry")
          } else if (medicineExpiryMonth >= nearExpiryMonth) {
            setCategory("damage")
          }
        } else if (expiryDate && expiryDate < sixMonthsAgo) {
          setCategory("over-expiry")
        }
      } else if (getDecryptedSessionItem("reportType") === "bluecross") {
        const assumedExpiryMonth = currentMonth + 5
        if (currentYear > expiryDate.getFullYear()) {
          setCategory("expiry")
        } else if (currentYear === expiryDate.getFullYear()) {
          if (
            (currentMonth < medicineExpiryMonth &&
              medicineExpiryMonth <= assumedExpiryMonth) ||
            currentMonth >= medicineExpiryMonth
          ) {
            setCategory("expiry")
          } else {
            setCategory("damage")
          }
        } else if (currentYear < expiryDate.getFullYear()) {
          if (assumedExpiryMonth > 12) {
            if (assumedExpiryMonth % 12 > medicineExpiryMonth) {
              setCategory("expiry")
            } else {
              setCategory("damage")
            }
          }
          setCategory("damage")
        }
      } else if (
        getDecryptedSessionItem("reportType") === "mankind" ||
        getDecryptedSessionItem("reportType") === "mkparekh"
      ) {
        if (currentYear > expiryDate.getFullYear()) {
          setCategory("expiry")
        }

        if (currentYear < expiryDate.getFullYear()) {
          setCategory("damage")

          if (nearExpiryMonth > 12) {
            if (nearExpiryMonth % 12 > medicineExpiryMonth) {
              setCategory("expiry")
            } else {
              setCategory("damage")
            }
          }
        }

        if (currentYear === expiryDate.getFullYear()) {
          if (nearExpiryMonth >= medicineExpiryMonth) {
            setCategory("expiry")
          } else {
            setCategory("damage")
          }
        }
      } else if (getDecryptedSessionItem("reportType") === "alkem") {
        // Alkem rules (comparing full month-year):
        // - Expiry: expiryDate <= current month-year
        // - Near Expiry: expiryDate in next 2 months
        // - Saleable: expiryDate from 3 months onwards

        // Calculate the expiry date as a number for easy comparison: year*12 + month
        const expiryDateValue = expiryDate.getFullYear() * 12 + medicineExpiryMonth;
        const currentDateValue = currentYear * 12 + currentMonth;

        // Next 2 months range
        const nearExpiryStartValue = currentDateValue + 1;
        const nearExpiryEndValue = currentDateValue + 2;

        if (expiryDateValue <= currentDateValue) {
          // Expiry: current month and earlier (till current month)
          setCategory("expiry");
        } else if (
          expiryDateValue >= nearExpiryStartValue &&
          expiryDateValue <= nearExpiryEndValue
        ) {
          // Near Expiry: next 1-2 months
          setCategory("near expiry");
        } else {
          // Saleable: 3 months and beyond
          setCategory("saleable");
        }
      } else if (getDecryptedSessionItem("reportType") === "apex") {
        console.log("In apex block");
        if (expiryDate && expiryDate < sixMonthsAgo) {
          setCategory("over-expiry");
        } else if (
          expiryDate &&
          sixMonthsAgo <= expiryDate &&
          expiryDate <= today
        ) {
          setCategory("expiry");
        } else if (expiryDate && expiryDate > today) {
          setCategory("damage");
        } else {
          setCategory("Saleable");
        }
      } else if (getDecryptedSessionItem("reportType") === "zydus") {
        const expiryDateMonth = expiryDate.getMonth() + 1;
        const expiryDateYear = expiryDate.getFullYear();
        const diffInMonths = (expiryDateYear - currentYear) * 12 + (expiryDateMonth - currentMonth);

        if (diffInMonths <= 1) {
          setCategory("expiry");
        } else if (diffInMonths >= 2 && diffInMonths <= 5) {
          setCategory("near expiry");
        } else {
          setCategory("saleable");
        }
      } else if (getDecryptedSessionItem("reportType") === "corona") {
        const expiryDateMonth = expiryDate.getMonth() + 1;
        const expiryDateYear = expiryDate.getFullYear();
        const diffInMonths = (expiryDateYear - currentYear) * 12 + (expiryDateMonth - currentMonth);

        if (diffInMonths <= 1) {
          setCategory("expiry");
        } else if (diffInMonths >= 2 && diffInMonths <= 5) {
          setCategory("near expiry");
        } else {
          setCategory("saleable");
        }
      }
      else if (getDecryptedSessionItem("reportType") === "torrent") {
        console.log("In other block torrent");
        if (expiryDate && expiryDate < sixMonthsAgo) {
          setCategory("over-expiry")
        } else if (
          expiryDate &&
          sixMonthsAgo <= expiryDate &&
          expiryDate <= today
        ) {
          setCategory("expiry")
        } else if (expiryDate && expiryDate > today) {
          setCategory("saleable")
        } else {
          setCategory("damage")
        }
      } else {
        if (expiryDate && expiryDate < sixMonthsAgo) {
          setCategory("over-expiry")
        } else if (
          expiryDate &&
          sixMonthsAgo <= expiryDate &&
          expiryDate <= today
        ) {
          setCategory("expiry")
        } else if (expiryDate && expiryDate > today) {
          setCategory("damage")
        } else {
          setCategory("")
        }
      }
    }
  }

  const onStopSession = () => {
    const url = `${getDecryptedSessionItem("server")}/scan/stop-session`

    axios
      .post(
        url,
        { sessionId: getDecryptedSessionItem("session_id") },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((response) => {
        const result = response.data
        if (result["status"] === "success") {
          toast.success("successfully stopped session")
          sessionStorage.removeItem("request_id")
          sessionStorage.removeItem("session_id")
          navigate("/export-reports")
        } else {
          toast.error(result["error"])
        }
      })
  }

  const getLastDayOfMonth = (dateString) => {
    const [month, year] = dateString.split("-")
    const nextMonthFirstDay = new Date(year, month, 1)
    const lastDayOfMonth = new Date(nextMonthFirstDay - 1)
    const formattedDate = `${lastDayOfMonth.getDate()}/${String(month).padStart(
      2,
      "0"
    )}/${year}`
    return formattedDate
  }

  let values = null
  let options = null

  let genericOptionsMap = new Map([
    ["Expiry", "expiry"],
    ["Damage", "damage"],
  ]);
  let lupinOptionsMap = new Map([
    ["Over Expiry", "over-expiry"]
  ]);
  let torrentOptionsMap = new Map([
    ["Saleable", "saleable"]
  ]);
  let alkemOptionsMap = new Map([
    ["Saleable", "saleable"],
    ["Near expiry", "near expiry"]
  ]);
  let apexOptionsMap = new Map([
    ['Near expiry', 'near expiry'],
    ['Over expiry', 'over-expiry'],
    ['Saleable', 'Saleable'],
  ])

  let mankindOptionsMap = new Map([
    ["E", "expiry"],
    ["B", "damage"],
  ])

  let zydusOptionsMap = new Map([
    ["Near expiry", "near expiry"],
    ["Over expiry", "over-expiry"],
    ["Saleable", "saleable"],
  ]);
   let coronaOptionsMap = new Map([
    ["Near expiry", "near expiry"],
    ["Saleable", "saleable"],
  ]);

  let intasOptionsMap = new Map([["Near expiry", "near expiry"]])

  let bluecrossOptionsMap = new Map([["Over Expiry", "over-expiry"]])

  if (
    getDecryptedSessionItem("reportType") === "mankind" ||
    getDecryptedSessionItem("reportType") === "mkparekh"
  ) {
    values = mankindOptionsMap
  } else if (getDecryptedSessionItem("reportType") === "intas") {
    let mergedIntasAndGeneric = new Map([
      ...intasOptionsMap,
      ...genericOptionsMap,
    ])
    values = mergedIntasAndGeneric
  } else if (getDecryptedSessionItem("reportType") === "lupin") {
    let mergedIntasAndGeneric = new Map([
      ...lupinOptionsMap,
      ...genericOptionsMap,
    ])
    values = mergedIntasAndGeneric
  } else if (getDecryptedSessionItem("reportType") === "torrent") {
    let mergedIntasAndGeneric = new Map([
      ...torrentOptionsMap,
      ...genericOptionsMap,
    ]);
    values = mergedIntasAndGeneric;
  }
  else if (getDecryptedSessionItem("reportType") === "alkem") {
    let mergedIntasAndGeneric = new Map([
      ...alkemOptionsMap,
      ...genericOptionsMap,
    ]);
    values = mergedIntasAndGeneric;
  }
  else if (getDecryptedSessionItem("reportType") === "apex") {
    let mergedapexAndGeneric = new Map([
      ...apexOptionsMap,
      ...genericOptionsMap,
    ]);
    values = mergedapexAndGeneric
  }
  else if (getDecryptedSessionItem("reportType") === "bluecross") {
    let mergedBluecrossAndGeneric = new Map([
      ...bluecrossOptionsMap,
      ...genericOptionsMap,
    ])
    values = mergedBluecrossAndGeneric
  }
  else if (getDecryptedSessionItem("reportType") === "zydus") {
    let mergedZydusAndGeneric = new Map([
      ...zydusOptionsMap,
      ...genericOptionsMap,
    ]);
    values = mergedZydusAndGeneric;
  }
  else if (getDecryptedSessionItem("reportType") === "corona") {
    let mergedCoronaAndGeneric = new Map([
      ...coronaOptionsMap,
      ...genericOptionsMap,
    ]);
    values = mergedCoronaAndGeneric;
  }
  else {
    values = genericOptionsMap
  }

  if (values) {
    options = Array.from(values).map(([key, values]) => (
      <option value={values}>{key}</option>
    ))
    options.push(<option></option>)
  }
  useEffect(() => {
    return () => {
      setScanActive(false);
    };
  }, [setScanActive]);


  return (
    <div style={{ display: "flex", gap: 10 }}>
      {multipleData?.length > 0 ? (
        <ConfirmationDialog
          id="ringtone-menu"
          keepMounted
          open={open}
          onClose={handleClose}
          value={value}
          rows={multipleData}
          setMultipleData={setMultipleData}
        />
      ) : (
        <></>
      )}

      <div
        className={classes.container}
        ref={containerRef}
        tabIndex={-1}
        style={{ outline: 'none' }}
      >
        <div className="card">
          {!currentItem && (
            <div className={classes.overlay}>
              <h2 className={classes.centerTitle}>Waiting for new scan...</h2>
            </div>
          )}
          <div>
            <div className="row">
              <div className="col">
                <div className={classes.imageContainer}>
                  <img
                    className={classes.image}
                    src={`data:image/png;base64,${scannedImage}`}
                    alt="image"
                  />
                </div>
              </div>
              <div className="col" style={{ padding: 20 }}>
                <div className="row">
                  <div className="col">
                    <div className="row">
                      <div className="col">
                        <span className={classes.label}>Type: </span>
                        <span>{ } </span>
                      </div>
                      <div className="col">
                        <span className={classes.label}>PartyName: </span>
                        <span>{clientName}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row" style={{ marginTop: 10 }}>
                  <div className="row">
                    <div className="col">
                      <div className="row">
                        <div className="col">
                          <div className="mb-3">
                            <label htmlFor="">Batch Number</label>
                            <BatchNumberFinder
                              ref={batchInputRef}
                              defaultValue={batch}
                              onChange={(value) => {
                                setBatch(sanitizeValue(value.trim()))
                              }}
                              onSelectProduct={(item) => {
                                setSelect(true)
                                setBatch(item["batch"])
                                setOBatch(sanitizeValue(item["obatch"]))
                                setItemCode(sanitizeValue(item["itemCode"]))
                                setSku(sanitizeValue(item["sku"]))
                                setMRP(sanitizeValue(item["mrp"]))
                                setOptional1(item["optional1"])
                                setOptional2(item["optional2"])
                                setBarcode2(item["barcode2"])

                                const expiryDates = item["expiryDate"]

                                if (expiryDates.length === 7) {
                                  const result = moment(expiryDates, [
                                    "MM-YYYY",
                                    moment.ISO_8601,
                                    moment.RFC_2822,
                                    moment.defaultFormat,
                                  ])
                                    .endOf("month")
                                    .format("YYYY-MM-DD")

                                  setExpiry(result)
                                  calculateCategories(new Date(result))
                                }

                                const mfgDate = item["mfgDate"]
                                if (mfgDate.length === 7) {
                                  const result = moment(mfgDate, [
                                    "MM-YYYY",
                                    moment.ISO_8601,
                                    moment.RFC_2822,
                                    moment.defaultFormat,
                                  ])
                                    .startOf("month")
                                    .format("YYYY-MM-DD")
                                  setMfg(result)
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="row">
                        <div className="col">
                          <div className="mb-3">
                            <label htmlFor="">Product Name</label>
                            <input
                              type="text"
                              className="form-control"
                              value={sku}
                              onChange={(e) => {
                                setSku(sanitizeValue(e.target.value))
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col">
                      <div className="mb-3">
                        <label htmlFor="">Product Code</label>
                        <input
                          type="text"
                          className="form-control"
                          value={itemCode}
                          onChange={(e) => {
                            setItemCode(sanitizeValue(e.target.value))
                          }}
                        />
                      </div>
                    </div>
                    <div className="col">
                      <div className="mb-3">
                        <label htmlFor="">Category</label>
                        <select
                          className="form-control"
                          value={category}
                          onChange={(e) => {
                            setCategory(e.target.value)
                          }}
                          disabled={
                            getDecryptedSessionItem("reportType") === "intas"
                              ? true
                              : false
                          }
                        >
                          {options}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col">
                      <div className="mb-3">
                        <label htmlFor="">Expiry Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={expiry}
                          onChange={(e) => {
                            setExpiry(e.target.value)
                            calculateCategories(new Date(e.target.value))
                          }}
                        />
                      </div>
                    </div>
                    <div className="col">
                      <div className="mb-3">
                        <label htmlFor="">MFG Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={mfg}
                          onChange={(e) => {
                            setMfg(e.target.value)
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col">
                      <div className="mb-3">
                        <label htmlFor="">MRP</label>
                        <input
                          type="number"
                          className="form-control"
                          value={mrp}
                          onChange={(e) => {
                            setMRP(sanitizeValue(e.target.value))
                          }}
                        />
                      </div>
                    </div>
                    <div className="col">
                      <div className="mb-3">
                        <label htmlFor="">Quantities</label>
                        <input
                          value={quantity}
                          type="number"
                          className="form-control"
                          onChange={(e) => {
                            setQuantity(sanitizeValue(e.target.value))
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="card-footer"
            style={{
              padding: 10,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>
              <button
                disabled={isProcessing}
                onClick={() => confirmScan(id)}
                className="btn btn-success"
              >
                {isProcessing ? "Processing..." : "Confirm (Enter)"}
              </button>
              <button
                disabled={isProcessing}
                onClick={() => deleteScan(id)}
                className="btn btn-danger"
                style={{ marginLeft: 10 }}
              >
                Discard (Esc)
              </button>
            </div>
          </div>
        </div>
      </div>
      <button
        style={{ alignSelf: "center" }}
        onClick={() => onStopSession()}
        className="btn btn-danger"
      >
        Stop Session
      </button>
    </div>
  )
}

export default ScanResult;

function ConfirmationDialog(props) {
  const {
    onClose,
    value: valueProp,
    open,
    rows,
    setMultipleData,
    ...other
  } = props;
  const [value, setValue] = React.useState(valueProp);
  const radioGroupRef = React.useRef(null);
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState("");
  const { getDecryptedSessionItem } = useContext(MyContext);
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  React.useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }
  }, [valueProp, open]);

  const handleEntering = () => {
    if (radioGroupRef.current != null) {
      radioGroupRef.current.focus();
    }
  };

  const handleOk = async () => {
    const singleData = rows.find((r) => r.id == selectedValue);

    const body = {
      quantity: "1",
      category: calculateCategories(
        new Date(
          moment(singleData.expiry, [
            "MM-YYYY",
            moment.ISO_8601,
            moment.RFC_2822,
            moment.defaultFormat,
          ])
            .endOf("month")
            .format("YYYY-MM-DD")
        )
      ),
      batch: singleData.batch,
      expiryDate: singleData.expiry
        ? moment(singleData.expiry, [
          "MM-YYYY",
          moment.ISO_8601,
          moment.RFC_2822,
          moment.defaultFormat,
        ])
          .endOf("month")
          .format("MM-YYYY")
        : "nan",
      mfgDate: singleData.mfg
        ? singleData.mfg !== "nan"
          ? moment(singleData.mfg, [
            "MM-YYYY",
            moment.ISO_8601,
            moment.RFC_2822,
            moment.defaultFormat,
          ])
            .startOf("month")
            .format("MM-YYYY")
          : "nan"
        : "nan",
      mrp: singleData.mrp,
      itemCode: singleData.itemCode,
      sku: singleData.sku,
      request_id: getDecryptedSessionItem("request_id"),
      session_id: getDecryptedSessionItem("session_id"),
      optional1: singleData.optional1,
      optional2: singleData.optional2,
      barcode1: singleData.barcode1,
      barcode2: singleData.barcode2,
      scannedImage: singleData.scannedImage,
      searchType: "auto",
      obatch: singleData.obatch,
      input: "",
      clientCode: singleData.clientCode,
      clientName: singleData.clientName,
      region: singleData.region,
      lrDate: singleData.lrDate,
      recDate: singleData.recDate,
      remark: singleData.remark,
      platform: "Auto Confirm - Multi",
      // platform : category !== 'expiry'
      // ? 'Manual - Category'
      // : quantity !== '1'
      // ? 'Manual - Quantity'
      // : mBatch !== batch
      // ? 'Manual - Batch'
      // : 'Auto - Confirm',
    };

    if (getDecryptedSessionItem("reportType") === "intas") {

      let currentMonth = new Date().getMonth() + 1;
      let currentYear = new Date().getFullYear();

      let expiryDateMonth = Number(body.expiry?.split("-")[0]);
      let expiryDateYear = Number(body.expiry?.split("-")[1]);

      if (
        body.category !== "over-expiry" &&
        body.category !== "expiry" &&
        currentMonth + 2 >= expiryDateMonth &&
        currentYear == expiryDateYear
      ) {
        body.category = "near expiry";
      }
      body.category =
        body.category === "near expiry"
          ? "near expiry"
          : body.category === "over-expiry" || body.category === "expiry"
            ? "expiry"
            : "damage";
    }
    const response = await updateTransaction(body);
    if (response["status"] == "success") {
      toast.success("updated transaction successfully");
    } else {
      toast.error(response["error"]);
    }
    dispatch(increment());

    onClose(value);
    setMultipleData([]);
  };
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    if (rows?.length > 0 && selectedValue === null) {
      const firstId = rows[0].id;
      setSelectedValue(firstId);
      handleChange({ target: { value: firstId } });
    }
  }, [rows, selectedValue, handleChange]);
  useEffect(() => {
    if (rows?.length > 0) {
      const firstId = rows[0].id;
      setSelectedValue(firstId);
    }
  }, [rows]);
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (!rows?.length) return;

      const currentIndex = rows.findIndex((row) => row.id === selectedValue);

      if (e.key === "ArrowUp") {
        e.preventDefault();
        const newIndex = Math.max(0, currentIndex - 1);
        const newId = rows[newIndex]?.id;
        if (newId !== undefined) {
          setSelectedValue(newId);
        }
      }

      if (e.key === "ArrowDown") {
        e.preventDefault();
        const newIndex = Math.min(rows.length - 1, currentIndex + 1);
        const newId = rows[newIndex]?.id;
        if (newId !== undefined) {
          setSelectedValue(newId);
        }
      }

      if (!isNaN(e.key) && +e.key >= 1 && +e.key <= rows.length) {
        const newIndex = +e.key - 1;
        const newId = rows[newIndex]?.id;
        if (newId !== undefined) {
          setSelectedValue(newId);
          setSelectedId(newId);
        }
      }

      if (e.key === "Enter") {
        if (selectedValue) {
          setSelectedId(selectedValue);
        }
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [rows, selectedValue]);

  useEffect(() => {
    if (selectedId !== null) {
      const selectedRow = rows?.find((row) => row.id === selectedId);
      if (selectedRow && selectedRow.expiry !== undefined) {
        handleOk();
      }
    }
  }, [selectedId, rows, handleOk]);

  function calculateCategories(expiryDate) {
    if (expiryDate) {
      let date = new Date();
      let today = new Date(date.setMonth(date.getMonth() + 1));
      // console.log("Today date : ", today);
      var sixMonthsAgo = new Date(today);
      // console.log("Six month date : ", sixMonthsAgo);
      sixMonthsAgo.setMonth(today.getMonth() - 6);
      // console.log("Six month ago date : ", sixMonthsAgo);

      const currentMonth = new Date().getMonth() + 1;
      const currentYear = new Date().getFullYear();
      const medicineExpiryMonth = expiryDate.getMonth() + 1;
      const nearExpiryMonth = currentMonth + 2;

      if (getDecryptedSessionItem("reportType") === "intas") {

        if (currentYear > expiryDate.getFullYear()) {
          return "expiry";
        } else if (currentYear < expiryDate.getFullYear()) {
          return "damage";
        } else if (currentYear === expiryDate.getFullYear()) {
          if (currentMonth > medicineExpiryMonth) {
            return "expiry";
          } else if (medicineExpiryMonth > nearExpiryMonth) {
            return "damage";
          } else {
            return "near expiry";
          }
        }
      } else {
        if (expiryDate && expiryDate < sixMonthsAgo) {
          return "over-expiry";
        } else if (
          expiryDate &&
          sixMonthsAgo <= expiryDate &&
          expiryDate <= today
        ) {
          return "expiry";
        } else if (expiryDate && expiryDate > today) {
          return "damage";
        } else {
          return "";
        }
      }
    }
  }

  const handleCancel = async () => {
    try {
      await resumeScan();
    } catch (error) {
      console.error("Failed to resume scan on dialog cancel:", error);
    }
    onClose();
    setMultipleData([]);
  };

  return (
    <Dialog
      sx={{ "& .MuiDialog-paper": { maxWidth: "72%", maxHeight: "72%" } }}
      maxWidth="xs"
      TransitionProps={{ onEntering: handleEntering }}
      open={open}
      onClose={handleCancel}
      {...other}
    >
      <DialogTitle>Please select product</DialogTitle>
      <DialogContent dividers>
        {/* <RadioGroup
          ref={radioGroupRef}
          aria-label="ringtone"
          name="ringtone"
          value={value}
          onChange={handleChange}
        >
          {options.map((option) => (
            <FormControlLabel
              value={option}
              key={option}
              control={<Radio />}
              label={option}
            />
          ))}
        </RadioGroup> */}
        {/* <MyTable rows={rows} /> */}

        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>SrNo</TableCell>
                <TableCell>Item Code</TableCell>
                <TableCell>Product Name</TableCell>
                <TableCell>Batch</TableCell>
                <TableCell>Expiry</TableCell>
                <TableCell>Mfg</TableCell>
                <TableCell>Mrp</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows?.map((row, index) => (
                <TableRow
                  key={row?.id}
                  onClick={() => {
                    setSelectedId(row.id);
                    handleChange({ target: { value: row.id } });
                  }}
                >
                  <TableCell>
                    <Radio
                      checked={String(selectedValue) === String(row.id)}
                      onChange={handleChange}
                      value={row.id}
                      name="radio-buttons"
                    />
                  </TableCell>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row?.itemCode}</TableCell>
                  <TableCell>{row?.sku}</TableCell>
                  <TableCell>{row?.batch}</TableCell>
                  <TableCell>{row?.expiry}</TableCell>
                  <TableCell>{row?.mfg}</TableCell>
                  <TableCell>{row?.mrp}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>

      <Button autoFocus onClick={handleCancel}>
        Cancel
      </Button>

    </Dialog>
  );
}
